// extracted by mini-css-extract-plugin
export default {"container":"Ui-z","modal":"Vi-z"};